import { useQuery } from "@/hooks/useQuery";
import { ApiResponse, StoreData } from "@/types";
import apiClient from "@/utils/apiClient";
import { useAppSelector } from "@/store";


interface StoreDataResponse {
  data: StoreData | null;
  isLoading: boolean;
  error?: unknown;
  refetch: () => void;
}

export const useStoreData = (): StoreDataResponse => {
  const { merchantId, storeId } = useAppSelector((state) => state.auth.context);

  const { data, isLoading, error, refetch } = useQuery<StoreData>({
    queryKey: ["storeDetails", merchantId || "", storeId || ""],
    queryFn: async () => {
      try {
        const response = await apiClient.get<ApiResponse<StoreData>>(
          `/onboarding/store/details`,
        );
        return response.data.data;
      } catch (error) {
        console.error("Failed to fetch store details:", error);
        throw error;
      }
    },
  });

  return { data, isLoading, error, refetch };
};
